import React, { useEffect, useRef, useState } from "react";
import { View } from "@/styles/reactnative";
import { TradeRealTimeContainer } from "./styles";

import OrderBook from "./OrderBook";
import TradeRealTimeFilter from "./TradeRealTimeFilter";
import { FloatBtnSection3 } from "../../../components/CFloatBtns/styles";
import { useTradeModalStore } from "../../../hooks/trade/modalStore";
import { useWindowDimensions } from "../../../hooks";
import { IconArrowsMove } from "@tabler/icons-react";
import useTradeStore from "../../../hooks/trade/tradeStore";
import CrossIcon from '../assets/CrossIcon.svg?react'
import { useBinanceWebSocketStore } from '@app/hooks/binanceWebsocketStore.ts';
import { useCiTradeWebSocketStore } from '@app/hooks/ciTradeWebsocketStore.ts';

const TradeRealTime = ({ drag, setOrderBookValue }) => {
  const [topTab, setTopTab] = useState("orderBook");
  const [filterTab, setFilterTab] = useState("one");
  const { width: w, height: h } = useWindowDimensions();
  const { data: tradeStore } = useTradeStore();

  const setSymbol = useCiTradeWebSocketStore((s) => s.setSymbol);
  const closeSocket = useCiTradeWebSocketStore((s) => s.closeSocket);

  // 바이낸스 심볼 세팅
  const previousSymbolRef = useRef<string | null>(null);

  useEffect(() => {
    if (!tradeStore?.pairs) return;

    const rawSymbol = tradeStore.pairs.replace("/", "").toLowerCase();
    if (rawSymbol !== previousSymbolRef.current) {
      previousSymbolRef.current = rawSymbol;
      setSymbol(rawSymbol);
    }

    return () => {
      closeSocket();
    };
  }, [tradeStore?.pairs]);


  const orderBook = topTab === "orderBook";

  const { data: tradeModalStore, mutate: muateTradeModalStore } =
    useTradeModalStore();

  const [height, setHeight] = useState(500);

  const parentRef = useRef<any>(null);

  useEffect(() => {
    if (parentRef.current) {
      if (parentRef.current?.clientHeight != height) {
        setTimeout(() => {
          setHeight(parentRef.current?.clientHeight - 100);
        }, 100);
        setTimeout(() => {
          setHeight(parentRef.current?.clientHeight - 100);
        }, 500);
      }
    }
  }, [w, h, parentRef.current?.clientHeight, drag]);

  const grouplist =
    tradeStore?.dp == 1 ? [100, 10, 1] : tradeStore?.dp == 2 ? [10, 1] : [1];

  for (let i = 1; i <= tradeStore?.dp; i++) {
    const value = parseFloat((0.1 ** i).toFixed(i));
    grouplist.push(value === 0 ? 1 : value);
  }

  const [selected, setSelected] = useState(grouplist[grouplist?.length - 1]);

  useEffect(() => {
    setSelected(grouplist[grouplist?.length - 1]);
  }, [tradeStore?.dp2, tradeStore?.ep_id]);

  return (
    <TradeRealTimeContainer ref={parentRef}>

      <View style={{ width: "100%", height: 65, display: 'flex', flexDirection: 'row', paddingRight: 10, alignItems: 'center' }}>
        <TradeRealTimeFilter
          filterTab={filterTab}
          setFilterTab={setFilterTab}
          grouplist={grouplist}
          selected={selected}
          setSelected={setSelected}
        />

        <div style={{display: 'flex', gap: 10}}>
          <FloatBtnSection3
            className={"drag-handle"}
          >
            <CrossIcon />
          </FloatBtnSection3>
          <FloatBtnSection3
            className="widgetClose"
            onClick={() => {
              muateTradeModalStore({
                ...tradeModalStore,
                orderbookshow: tradeModalStore?.orderbookshow ? false : true,
              });
            }}
          >
            X
          </FloatBtnSection3>
        </div>
      </View>
      <View
        style={{
          width: "100%",
          flex: 1,
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <OrderBook
          orderBook={orderBook}
          filterTab={filterTab}
          height={height}
          selected={selected}
          setOrderBookValue={setOrderBookValue}
        />
      </View>
    </TradeRealTimeContainer>
  );
};

export default React.memo(TradeRealTime);
